import api from '@mint-lib/api';

export type ApiResponse<T = any> = {
  success: boolean;
  data: T;
};

const callApi = async (
  url: string,
  params = {} as any,
): Promise<ApiResponse> => {
  const { method = 'GET', signal, ...options } = params;

  try {
    const response = await api.request({
      url,
      method,
      signal,
      ...options,
    });

    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      data: error.response?.data || 'Oops, Something went wrong',
    };
  }
};

export default callApi;
